module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAABE0lEQVRoQ+1Xu2rDQBDc1QP36YJbpdJX+C9cJtWi3qV/QwgdauLe4Np/4D4fkCapUgji9m7NYWTUWAGxJATmPmB2mZudnWUyfk3TLIkoH2CTJDmLyJdlGbYEi1jOuaOqPo1w9yKysaxj3nTbtm9EVI6afBWRZzRtyUDEAtN3GIWmIY+JYYM8IA/I44dthOWC5TIhEcgD8vhreXRd9xBCWFvlalXdEtHjCO/EzDsj/O80TQ/snCtVNZ5I/+G9hxBWaPoXvurKdF3XRZZlB8OCBREtRng9EX1Y4DPzp/f+BXkaeRp5Gnl6nqfAPeAecA+4B9xjHgNwD7gH3GPe7CB7RN7izZnn+e1G9N73VVWZ3IjDv1wAIlQAsO6PO2sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tupianT.png
// module id = bV74
// module chunks = 10